<script setup>

import {computed, onMounted, ref} from "vue";
import AppIcon from "@/components/AppIcon.vue";

const props = defineProps(['title', 'available', 'modelValue'])
const emits = defineEmits(['update:modelValue'])

const checked = ref(false)
const counter = computed({
  get: () => props.modelValue,
  set: value => {
    emits('update:modelValue', checked.value ? value : 0)
  }
})

function toggle(isChecked) {
  checked.value = isChecked
  counter.value = isChecked ? 1 : 0
}

onMounted(() => {
  if (counter.value > 0) {
    checked.value = true
  }
})
</script>

<template>
  <div class="addon">
    <label class="addon__label" :for="title">
      <input
          type="checkbox"
          class="ww-checkbox"
          :id="title"
          :name="title"
          :checked="checked"
          @change="toggle($event.target.checked)"
      />
      {{ $t(props.title) }}
    </label>

    <div class="addon__stepper" v-if="checked && props.available > 1">
      <button
          type="button"
          :aria-label="$t('decreaseAmount', {item: $t(props.title)})"
          :disabled="counter <= 1"
          @click.prevent="counter--"
      >
        <app-icon name="remove" :size="18"/>
      </button>
      <span class="addon__count">{{ counter }}</span>
      <button
          type="button"
          :aria-label="$t('increaseAmount', {item: $t(props.title)})"
          :disabled="counter >= props.available"
          @click.prevent="counter++"
      >
        <app-icon name="add" :size="18"/>
      </button>
    </div>
  </div>
</template>

<style scoped>
.addon {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
}

.addon + .addon {
  border-top: 1px solid var(--ww-border-line);
}

.addon__label {
  display: flex;
  align-items: center;
  gap: 11px;
  flex: 1 1 auto;
  min-width: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--ww-text);
  cursor: pointer;
}

.addon__stepper {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px;
  background: var(--ww-surface-sub-alt);
  border-radius: var(--ww-r-pill);
  flex: 0 0 auto;
}

.addon__stepper button {
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 50%;
  background: var(--ww-surface);
  color: var(--ww-navy-soft);
  box-shadow: var(--ww-shadow-pill);
}

.addon__stepper button:disabled {
  background: transparent;
  box-shadow: none;
  color: var(--ww-icon-faint);
}

.addon__count {
  min-width: 22px;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  color: var(--ww-text);
}
</style>
